import { curBookingsConstants } from 'store/constants';
import { EachFileSelected } from 'store/models/file-selected/file-selected.interface';
import { FileSelected } from 'store/models/file-selected/FileSelected';
import {
  ApiAttachmentForFS,
  FormattedMainFile,
} from 'store/models/MainFiles';
import {
  getCurFileSelectedSelector,
  commonPagesSelector,
  isSelectedDestFileSelectedIndexes,
} from 'store/selectors/cur-bookings-attachments.selector';

/**
 * append all pages
 * @param att
 */
const appendSrcFileToAttIndexes = (att: ApiAttachmentForFS) => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());
    const indexes = isSelectedDestFileSelectedIndexes(getState());
    if (!indexes.length)
      throw Error(`this shouldn't happend. No file selected.`);
    const newFileSelectedD = new FileSelected(
      fileSelected,
    ).appendSrcFileToAttIndexes(att, indexes);
    dispatch({
      type:
        curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
      payload: {
        fileSelected: newFileSelectedD,
      },
    });
  };
};

const appendPageToSelectedAttIndexes = (att, pageNo) => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());
    const indexes = isSelectedDestFileSelectedIndexes(getState());

    if (!indexes.length) {
      // add to the last
      dispatch(appendPageToAttIndex(att, pageNo));
    } else {
      // TODO: decide if should put the logic in the action or reducer
      const newFileSelectedD = new FileSelected(
        fileSelected,
      ).appendPageToAttIndexes(att, pageNo, indexes);
      dispatch({
        type:
          curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
        payload: {
          fileSelected: newFileSelectedD,
        },
      });
    }
  };
};

const appendPageToAttIndex = (
  att: FormattedMainFile,
  pageNo: number,
  fileIndex?: number,
) => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());
    // TODO: decide if should put the logic in the action or reducer
    const newFileSelectedD = new FileSelected(
      fileSelected,
    ).appendPageToAttIndex(att, pageNo, fileIndex);
    dispatch({
      type:
        curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
      payload: {
        fileSelected: newFileSelectedD,
      },
    });
  };
};

const addPageToAttIndexAfterPageIndex = (
  att: FormattedMainFile,
  pageNo: number,
  fileIndex?: number,
  pageIndex?: number,
) => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());
    // TODO: decide if should put the logic in the action or reducer
    const newFileSelectedD = new FileSelected(
      fileSelected,
    ).addPageToAttIndexAfterPageIndex(
      att,
      pageNo,
      fileIndex,
      pageIndex,
    );
    dispatch({
      type:
        curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
      payload: {
        fileSelected: newFileSelectedD,
      },
    });
  };
};

const updateFileSelected = (fileSelected: EachFileSelected) => {
  return {
    type: curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
    payload: {
      fileSelected,
    },
  };
};

/**
 *
 * @param srcFile
 * @param isSelectAll
 * @param pageNum
 */
const appendSrcFile = (
  srcFile: ApiAttachmentForFS,
  isSelectAll: boolean,
  pageNum?: number,
) => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());
    const commonPages = commonPagesSelector(getState());
    // TODO: decide if should put the logic in the action or reducer

    let newFileSelectedD: EachFileSelected[];

    const afterAppend = new FileSelected(
      fileSelected,
      true,
    ).appendSrcFile(srcFile, isSelectAll, pageNum) as FileSelected;

    if (!commonPages.length) {
      newFileSelectedD = afterAppend.fileSelected;
    } else {
      newFileSelectedD = (afterAppend.addCommonPagesToLastDestFile(
        commonPages,
      ) as FileSelected).fileSelected;
    }

    dispatch({
      type:
        curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
      payload: {
        fileSelected: newFileSelectedD,
      },
    });
  };
};

const appendManySrcFiles = (
  srcFiles: FormattedMainFile[],
  isSelectAll: boolean,
  replaceOld?: boolean,
) => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());
    const newFileSelectedD = new FileSelected(
      fileSelected,
    ).appendManySrcFiles(srcFiles, isSelectAll, replaceOld);

    dispatch({
      type:
        curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
      payload: {
        fileSelected: newFileSelectedD,
      },
    });
  };
};

const useManySrcFiles = (
  srcFiles: ApiAttachmentForFS[],
  isSelectAll: boolean,
) => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());
    const commonPages = commonPagesSelector(getState());
    let newFileSelectedD: EachFileSelected[];
    let afterAppend = new FileSelected(
      fileSelected,
      true,
    ).useManySrcFiles(srcFiles, isSelectAll) as FileSelected;

    if (!commonPages.length) {
      newFileSelectedD = afterAppend.fileSelected;
    } else {
      newFileSelectedD = (afterAppend.addCommonPagesToAllDestFiles(
        commonPages,
      ) as FileSelected).fileSelected;
    }

    dispatch({
      type:
        curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
      payload: {
        fileSelected: newFileSelectedD,
      },
    });
  };
};

/**
 *
 * @param srcFile
 * @param pageNo if pageNo is undefined will use all pages
 */
const prependPagesToAllDestFiles = (
  srcFile: FormattedMainFile,
  pageNo?: number,
) => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());
    const newFileSelectedD = new FileSelected(
      fileSelected,
    ).prependPagesToAllDestFiles(srcFile, pageNo);

    dispatch({
      type:
        curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
      payload: {
        fileSelected: newFileSelectedD,
      },
    });
  };
};

const splitSrcFileAndAdd = (srcFile: ApiAttachmentForFS) => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());
    const commonPages = commonPagesSelector(getState());
    // TODO: decide if should put the logic in the action or reducer
    let newFileSelectedD: EachFileSelected[];
    const afterAppend = new FileSelected(
      fileSelected,
      true,
    ).splitSrcFileAndAdd(srcFile) as FileSelected;

    if (!commonPages.length) {
      newFileSelectedD = afterAppend.fileSelected;
    } else {
      newFileSelectedD = (afterAppend.addCommonPagesToLastDestFile(
        commonPages,
        srcFile.pages.length,
      ) as FileSelected).fileSelected;
    }

    dispatch({
      type:
        curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
      payload: {
        fileSelected: newFileSelectedD,
      },
    });
  };
};

/**
 * TODO: rethink about passing fileSelected
 * TODO: consider about adding a new action type specifically for setSelectFileAtIndex
 * @param fileSelected
 * @param destFileIndex
 * @param checked
 */
const setSelectFileAtIndex = (
  destFileIndex: number,
  checked: boolean,
) => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());
    const newFileSelectedD = new FileSelected(
      fileSelected,
    ).setSelectFileAtIndex(destFileIndex, checked);

    dispatch({
      type:
        curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
      payload: {
        fileSelected: newFileSelectedD,
      },
    });
  };
};

const renameFileAtIndex = (
  destFileIndex: number,
  newName: string,
) => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());
    const newFileSelectedD = new FileSelected(
      fileSelected,
    ).renameFileAtIndex(destFileIndex, newName);

    dispatch({
      type:
        curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
      payload: {
        fileSelected: newFileSelectedD,
      },
    });
  };
};

const setSelectFileAtAllIndexes = (checked: boolean) => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());
    const newFileSelectedD = new FileSelected(
      fileSelected,
    ).setSelectFileAtAllIndexes(checked);

    dispatch({
      type:
        curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
      payload: {
        fileSelected: newFileSelectedD,
      },
    });
  };
};

const removeFileAtIndex = (index: number) => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());
    const newFileSelectedD = new FileSelected(
      fileSelected,
    ).removeFileAtIndex(index);

    dispatch({
      type:
        curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
      payload: {
        fileSelected: newFileSelectedD,
      },
    });
  };
};

const removeAllSelectedFiles = () => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());
    const newFileSelectedD = new FileSelected(
      fileSelected,
    ).removeAllSelectedFiles();

    dispatch({
      type:
        curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
      payload: {
        fileSelected: newFileSelectedD,
      },
    });
  };
};

const resetFileSelected = () => {
  return {
    type: curBookingsConstants.RESET_FILE_SELECTED_AT_VIEWING_INDEX,
  };
};

const removePage = (destFileIndex: number, pageIndex: number) => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());
    const newFileSelectedD = new FileSelected(
      fileSelected,
    ).removePage(destFileIndex, pageIndex);

    dispatch({
      type:
        curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
      payload: {
        fileSelected: newFileSelectedD,
      },
    });
  };
};

const movePage = (
  destOldFileIndex: number,
  oldPageIndex: number,
  destNewFileIndex: number,
  insertAfterPageIndex: number, // TODO: consider renaming to newPageIndex
) => {
  return (dispatch, getState) => {
    const fileSelected = getCurFileSelectedSelector(getState());

    const newFileSelectedD = new FileSelected(fileSelected).movePage(
      destOldFileIndex,
      oldPageIndex,
      destNewFileIndex,
      insertAfterPageIndex,
    );

    dispatch({
      type:
        curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
      payload: {
        fileSelected: newFileSelectedD,
      },
    });
  };
};

export const fileSelectedActions = {
  addPageToAttIndexAfterPageIndex,
  updateFileSelected,
  appendSrcFile,
  appendManySrcFiles,
  useManySrcFiles,
  splitSrcFileAndAdd,
  prependPagesToAllDestFiles,
  setSelectFileAtIndex,
  setSelectFileAtAllIndexes,
  removeFileAtIndex,
  removeAllSelectedFiles,
  resetFileSelected,
  removePage,
  movePage,
  renameFileAtIndex,

  appendPageToAttIndex,
  appendPageToSelectedAttIndexes, // add to the last index if no selected
  appendSrcFileToAttIndexes,
};
